import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { ArticleItem } from '@domains/article';

import { makeAllArticlesRoute } from '@utils/route';

import { useEmbla } from '@hooks/use-embla';

import { ArticleCard } from '@components/article/ArticleCard/ArticleCard';
import { Container } from '@components/common/Container/Container';
import { SliderBlockTitle } from '@components/common/SliderBlockTitle/SliderBlockTitle';
import { SliderNavigation } from '@components/common/SliderNavigation/SliderNavigation';
import { SliderPagination } from '@components/common/SliderPagination/SliderPagination';

import styles from './ArticlesSlider.module.scss';

export type ArticlesSliderProps = {
    articles: ArticleItem[];
    title?: string;
    hasPagination?: boolean;
    className?: string;
};

export const ArticlesSlider: FunctionComponent<ArticlesSliderProps> = (props) => {
    const { articles, hasPagination, className, title = 'Акции и новости' } = props;

    const {
        scrollPrev,
        scrollNext,
        isPrevButtonEnabled,
        isNextButtonEnabled,
        viewportRef,
        scrollSnaps,
        scrollTo,
        selectedIndex,
    } = useEmbla({
        loop: false,
        startIndex: 0,
        slidesToScroll: 1,
        containScroll: 'trimSnaps',
        align: 'start',
    });

    return (
        <div className={clsx(styles.root, className)}>
            <SliderBlockTitle title={title} link={makeAllArticlesRoute()} linkText="Смотреть все" />

            <Container classes={{ root: styles.container }}>
                <div className={styles.slider}>
                    <div ref={viewportRef} className={styles.viewport}>
                        <div className={styles.sliderContainer}>
                            {articles.map((article) => (
                                <ArticleCard
                                    key={article.slug}
                                    slug={article.slug}
                                    type={article.type}
                                    thumbnail={article.thumbnail}
                                    title={article.title}
                                    dates={article.dates}
                                    className={styles.slide}
                                />
                            ))}
                        </div>
                    </div>

                    <SliderNavigation
                        onPrev={scrollPrev}
                        onNext={scrollNext}
                        isPrevButtonEnabled={isPrevButtonEnabled}
                        isNextButtonEnabled={isNextButtonEnabled}
                        variation="circle"
                        classes={{ button: styles.navigationButton }}
                    />
                    {hasPagination && articles.length > 0 && scrollSnaps.length > 0 && (
                        <SliderPagination
                            scrollSnaps={scrollSnaps}
                            scrollTo={scrollTo}
                            selectedIndex={selectedIndex}
                            classes={{ root: styles.pagination }}
                        />
                    )}
                </div>
            </Container>
        </div>
    );
};
